import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PlatformProvider } from './contexts/PlatformContext.js';
import { AuthProvider } from './contexts/AuthContext.js';
import { BillingProvider } from './contexts/BillingContext.js';
import { LiveShareProvider } from './contexts/LiveShareContext.js';
import { SyncContextProvider } from './contexts/SyncContext.js';
import { ThemeProvider } from './contexts/ThemeContext.js';
import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import './styles/global.css';
import './styles/side-panel.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <PlatformProvider>
        <ThemeProvider>
          <AuthProvider>
            {/* Inside AuthProvider (needs authFetch) and outside the sync
                providers, so entitlement is known before any document work. */}
            <BillingProvider>
              <LiveShareProvider>
                <SyncContextProvider>
                  <App />
                </SyncContextProvider>
              </LiveShareProvider>
            </BillingProvider>
          </AuthProvider>
        </ThemeProvider>
      </PlatformProvider>
    </ErrorBoundary>
  </StrictMode>,
);
